// Auto-generated skeleton for AccountingYear

import { Building } from "./Building";

export const AccountingYear: Api.AccountingYear = {
  id: 0,
  hp_id: null,
  building_id: 0,
  year: 0,
  started_at: '',
  ended_at: '',
  building: Building,
  created: null,
  updated: null,
};

